import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateKanbanTicket } from '../services/postCreateKanbanTicket.service';

export const createKanbanTicket = createAsyncThunk(
  'kanban/createKanbanTicket',
  async ({ projectId, ticket }) => {
    const createdTicket = await postCreateKanbanTicket(projectId, ticket);
    return createdTicket;
  }
);
